<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-flex>
        <v-flex style="background-color: var(--secondary-color); padding: 10px">
          <label style="color: white; font-weight: 600; font-size: 20px"
            >Filtros</label
          >
        </v-flex>
      </v-flex>
      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
          :headers="headers"
          :items="data"
          :search="search"
          class="elevation-1 mt-2"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.user_id }}</td>
              <td class>{{ item.user.name }}</td>
              <td class>{{ item.discount_configuration.discount + ' %' }}</td>
              <td class>
                {{
                  item.discount_type
                    ? item.discount_type.title
                    : 'Desconto não selecionado.'
                }}
              </td>
              <td class>{{ item.discount_date | formatDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import UserDiscountHistoryController from '../../controllers/UserDiscountHistoryController.js';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import moment from 'moment';

export default {
  async created() {
    await this.getUserDiscountHistory();
  },
  data() {
    return {
      search: '',
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      userDiscountHistoryController: new UserDiscountHistoryController(
        this.$resource
      ),
      headers: [
        { text: 'ID do usuário', value: 'user_id' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Desconto', value: 'discount_configuration.discount' },
        {
          text: 'Desconto aplicado',
          value: 'discount_configuration_type.title',
        },
        { text: 'Mês de referência', value: 'discount_date' },
      ],
      data: [],
    };
  },

  methods: {
    async getUserDiscountHistory() {
      try {
        this.blockScreen = true;
        const response = await this.userDiscountHistoryController.getUserDiscountHistory();
        this.data = response.body;
      } catch (error) {
        console.error(err);
      } finally {
        this.blockScreen = false;
      }
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('MM[/]YYYY');
      }
    },
  },
};
</script>
<style>
.table-custom-vue {
  margin: 25px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
</style>
